export const TIME_SLOTS = [
  "09:30 AM",
  "10:00 AM",
  "10:30 AM",
  "11:00 AM",
  "11:30 AM",
  "12:00 PM",
  "12:30 PM",
  "01:00 PM",
  "01:30 PM",
  "02:00 PM",
  "02:30 PM",
  "03:00 PM",
  "03:30 PM",
  "04:00 PM",
  "04:30 PM",
  "05:00 PM",
  "05:30 PM",
  "06:00 PM",
  "06:30 PM",
  "07:00 PM",
  "07:30 PM",
  "08:00 PM",
  "08:30 PM",
  "09:00 PM",
  "09:30 PM",
];

export const HOME_TIME_SLOTS = [
  "09:30 AM",
  "11:00 AM",
  "12:30 PM",
  "02:00 PM",
  "03:30 PM",
  "05:00 PM",
  "06:30 PM",
  "08:00 PM",
  "09:30 PM",
];

export const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const DEFAULT_LAT = 25.2048;
export const DEFAULT_LNG = 55.2708;

export const INSPECTION_BUFFER_MS = 2 * 60 * 60 * 1000;

export const ALBA_PRICE_HIGH = 399;
export const ALBA_PRICE_LOW = 299;
export const HOME_PRICE = 499;
export const VALUATION_THRESHOLD = 250_000;
export const INSPECTION_API_URL = process.env.NEXT_PUBLIC_INSPECTION_API_URL!;

export const DISABLED_DATES: string[] = ["2026-04-10"];
